import { SubjectData } from 'shell/models/person';
import { AccordionResidencyPermit as ResidencyPermitVM } from 'shell/view-models/accordion-residency-permit';
import { DateTime } from 'luxon';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';

export const transformResidencyPermit = (person: SubjectData): ResidencyPermitVM | undefined => {
  const municipality: MunicipalityAnprVM = {
    id: person.permessoSoggiorno?.comune?.codiceIstat || '',
    description: person.permessoSoggiorno?.comune?.nomeComune || '',
    province: person.permessoSoggiorno?.comune?.siglaProvinciaIstat || '',
  };

  const originReturnData: ResidencyPermitVM | undefined = person.permessoSoggiorno
    ? {
        number: person.permessoSoggiorno?.numeroSoggiorno || '',
        type: person.permessoSoggiorno?.tipoSoggiorno || '',
        note: person.permessoSoggiorno?.noteSoggiorno || '',
        releaseDate: person.permessoSoggiorno?.dataRilascio
          ? DateTime.fromISO(person.permessoSoggiorno?.dataRilascio)
          : null,
        expirationDate: person.permessoSoggiorno?.dataScadenza
          ? DateTime.fromISO(person.permessoSoggiorno?.dataScadenza)
          : null,
        policeForceRelease: person.permessoSoggiorno?.questuraRilascioSoggiorno || '',
        municipality: person.permessoSoggiorno?.comune?.nomeComune ? municipality : null,
        province: person.permessoSoggiorno?.comune?.siglaProvinciaIstat || '',
        location: person.permessoSoggiorno?.comune?.descrizioneLocalita || '',
        passportNumber: person.permessoSoggiorno?.numeroPassaporto || '',
      }
    : undefined;

  return originReturnData;
};
